import {RSAA} from 'redux-api-middleware';

export const TOKEN_OBTAIN_PAIR_REQUEST = '@@auth/TOKEN_OBTAIN_PAIR_REQUEST',
    TOKEN_OBTAIN_PAIR_SUCCESS = '@@auth/TOKEN_OBTAIN_PAIR_SUCCESS',
    TOKEN_OBTAIN_PAIR_ERROR = '@@auth/TOKEN_OBTAIN_PAIR_ERROR',
    TOKEN_REFRESH_REQUEST = '@@auth/TOKEN_REFRESH_REQUEST',
    TOKEN_REFRESH_SUCCESS = '@@auth/TOKEN_REFRESH_SUCCESS',
    TOKEN_REFRESH_ERROR = '@@auth/TOKEN_REFRESH_ERROR',
    tokenObtainPair = (username, password) => ({
        [RSAA]: {
            endpoint: '/token/obtain-pair/',
            method: 'POST',
            body: JSON.stringify({username, password}),
            headers: {
                'Content-Type': 'application/json'
            },
            types: [TOKEN_OBTAIN_PAIR_REQUEST, TOKEN_OBTAIN_PAIR_SUCCESS, TOKEN_OBTAIN_PAIR_ERROR]
        }
    }),
    tokenRefresh = (refresh) => ({
        [RSAA]: {
            endpoint: '/token/refresh/',
            method: 'POST',
            body: JSON.stringify({refresh}),
            headers: {
                'Content-Type': 'application/json'
            },
            types: [TOKEN_REFRESH_REQUEST, TOKEN_REFRESH_SUCCESS, TOKEN_REFRESH_ERROR]
        }
    });


// WEBPACK FOOTER //
// ./src/actions/auth.js